module.exports = __webpack_public_path__ + "assets/img/34_879_big.570159d2.jpg";